"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EmojiShareModule = /** @class */ (function () {
    function EmojiShareModule() {
    }
    return EmojiShareModule;
}());
exports.EmojiShareModule = EmojiShareModule;
